import { Button, FormHelperText } from '@mui/material';
import { useContext } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { GoogleMapBox } from '../../../components/basic/GoogleMapBox';
import { GoogleSearchBox } from '../../../components/basic/GoogleSearchBox';
import { FormInput } from '../../../components/form/FormInput';
import { FormInputLabel } from '../../../components/form/FormInputLabel';
import { LangContext, UserContext } from '../../../contexts';
import { buttonStyle } from '../../../styles/style';
import { signUpFormValidations } from '../../user/components/sign-up/form';

export const ModifyForm = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    onSubmit,
    control,
    setError,
    errors,
    googleAddress,
    setGoogleAddress,
  } = props;
  const { isKorean } = useContext(LangContext);
  const { userInfo } = useContext(UserContext);
  const validations = signUpFormValidations(!isKorean);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off'>
      <section className='flex flex-col w-full gap-4 mb-6 container max-w-[560px] pt-10'>
        <header className='flex items-center border-b border-solid border-gray-500 pb-3 mb-3 justify-between'>
          <h2 className='font-semibold'>{t('LOGIN_INFO')}</h2>
          <em className='flex items-center gap-1 text-red-500'>
            <div className='ico required text-red-500'></div>
            <span className='text-sm text-red-500 font-semibold'>{t('REQUIRED')}</span>
          </em>
        </header>
        <div>
          <span className='text-sm text-gray-600'>{t('EMAIL')}: </span>
          <span className='text-sm font-medium'>{userInfo?.email}</span>
        </div>
        <div>
          <span className='text-sm text-gray-600'>{t('COMPANY_NAME')}: </span>
          <span className='text-sm font-medium'>{userInfo?.companyName}</span>
        </div>
        <div>
          <span className='text-sm text-gray-600'>{t('CEO_NAME')}: </span>
          <span className='text-sm font-medium'>{userInfo?.ceoName}</span>
        </div>
        <div>
          <span className='text-sm text-gray-600'>{t('BIZ_NUMBER')}: </span>
          <span className='text-sm font-medium'>{userInfo?.businessNumber}</span>
        </div>
        <div>
          <span className='text-sm text-gray-600'>{t('BIZ_CERT')}: </span>
          <span className='text-sm font-medium underline'>
            <a href={userInfo?.businessFile} target='_blank' rel='noopener noreferrer'>
              {t('BIZ_CERT')}
            </a>
          </span>
        </div>
        <div className='flex justify-end'>
          <span className='text-sm font-medium underline'>
            <Button
              variant='outlined'
              sx={{ ...buttonStyle }}
              onClick={() => {
                history.push('/user/reset_pw');
              }}
            >
              {t('CHANGE_PASSWORD')}
            </Button>
          </span>
        </div>
      </section>
      <section className='flex flex-col w-full gap-4 mb-6 container max-w-[560px] pt-10'>
        <header className='flex items-center border-b border-solid border-gray-500 pb-3 mb-3 justify-between'>
          <h2 className='font-semibold'>{t('MODIFY_MYINFO')}</h2>
          <em className='flex items-center gap-1 text-red-500'>
            <div className='ico required text-red-500'></div>
            <span className='text-sm text-red-500 font-semibold'>{t('REQUIRED')}</span>
          </em>
        </header>
        <div className='flex flex-col gap-4'>
          <FormInput {...register('name', validations.name)} label={t('RESPONSIBILITY')} required error={errors.name} />
          <FormInput
            {...(() => {
              const { onChange, ...rest } = register('phone', validations.phone);
              return {
                ...rest,
                onChange: (e) => {
                  const reg = new RegExp('^[0-9]{0,11}$');
                  const value = e.target.value;
                  if (reg.test(value)) {
                    onChange(e);
                  } else {
                    e.target.value = value.slice(0, -1);
                  }
                },
              };
            })()}
            label={t('MOBILE')}
            required
            error={errors.phone}
          />
          <div className='flex flex-col gap-1'>
            <Controller
              control={control}
              name='address.addr1'
              rules={validations['address.addr1']}
              error={errors.address?.addr1}
              render={({ field }) => (
                <>
                  <FormInputLabel label={t('HEADQ_ADDRESS')} isRequired />
                  <GoogleSearchBox value={googleAddress} onChange={(value) => setGoogleAddress(value)} />
                  <div className='rounded-lg border overflow-hidden'>
                    <GoogleMapBox initialAddress={googleAddress} onChange={(value) => field.onChange(value)} />
                  </div>
                  {errors.address?.addr1 && (
                    <FormHelperText error={errors.address?.addr1}>{errors.address?.addr1.message}</FormHelperText>
                  )}
                </>
              )}
            />
            <FormInput {...register('address.addr2')} placeholder={t('ADDRESS_DETAIL')} error={errors.address?.addr2} />
          </div>
          <FormInput {...register('site', validations.site)} label={t('HOMEPAGE')} error={errors.site} />
          <FormInput
            {...(() => {
              const { onChange, ...rest } = register('fax', validations.fax);
              return {
                ...rest,
                onChange: (e) => {
                  const reg = new RegExp('^[0-9]{0,11}$');
                  const value = e.target.value;
                  if (reg.test(value)) {
                    onChange(e);
                  } else {
                    e.target.value = value.slice(0, -1);
                  }
                },
              };
            })()}
            label={t('FAX')}
            error={errors.fax}
          />
        </div>
      </section>
      <section className='button__container '>
        <Button sx={{ ...buttonStyle, width: '180px' }} disableElevation type='submit' variant='contained'>
          {t('MODIFY')}
        </Button>
      </section>
    </form>
  );
};
